import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import CloseInCircleIcon from '@icons/CloseInCircleIcon';
import { ItemOption, OptionGroup } from '@models/item';
import { useFlow } from '@stackflow/react';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { pressActionEffect } from '@styles/mixin';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import NextIcon from './NextIcon';
import SelectedPersonalOptionList from './SelectedPersonalOptionList';

interface Props {
    itemId: string;
    personalOptionGroups: OptionGroup[];
}

/**
 * 퍼스널 옵션 열기 버튼 및 선택된 옵션 목록
 * @param itemId
 * @param personalOptionGroups
 * @constructor
 */
function PersonalOptionButton({ itemId, personalOptionGroups }:Props) {
    const { push } = useFlow();
    const itemActivityId = useItemActivityId();
    const { t } = useTranslation('item');
    const { optionCollapsed } = useAppCustom().item;
    if (personalOptionGroups.length > 0 && optionCollapsed) {
        return (
            <Fragment>
                <Container>
                    <ButtonRow
                        onClick={() => { push('PersonalOptionActivity', { itemId, itemActivityId }); }}
                        fullWidth
                        justify='space-between'>
                        <Text size='lg' fontWeight='bold'>{t('option.personal')}</Text>
                        <NextIcon/>
                        <Tooltip visibleKey='personalOption' top={-16} align='right' right={4}>
                            {t('option.personalTooltip')}
                        </Tooltip>
                    </ButtonRow>
                    <SelectedPersonalOptionList itemId={itemId} />
                </Container>
                <Divider/>
            </Fragment>
        );
    }
    return (<Fragment/>);
}

const Container = styled.div`
    width: 100%;
`;

const ButtonRow = styled(Row)`
    cursor: pointer;
    padding: 32px 18px 14px 20px;
    position: relative;
    ${pressActionEffect}
`;

export default PersonalOptionButton;
